import Confirm from './confirm';
export default Confirm;
